import React from 'react';
export function ValueTable() {
  return <section className="bg-navy-800 py-[72px] px-6" data-id="element-445">
      <div className="max-w-[720px] mx-auto" data-id="element-446">
        <h2 className="text-teal-400 uppercase text-[11px] tracking-widest font-bold text-center mb-10" data-id="element-447">
          EVERYTHING YOU GET TODAY
        </h2>

        <div className="rounded-[12px] overflow-hidden border border-white/10" data-id="element-448">
          <div className="bg-white/5 flex justify-between px-6 py-4 border-b border-white/10" data-id="element-449">
            <span className="text-white uppercase text-[11px] font-bold" data-id="element-450">
              ITEM
            </span>
            <span className="text-white uppercase text-[11px] font-bold" data-id="element-451">
              VALUE
            </span>
          </div>

          <div className="bg-navy-800" data-id="element-452">
            <div className="flex justify-between px-6 py-4 border-b border-white/5" data-id="element-453">
              <span className="text-white text-[15px]" data-id="element-454">
                The 11PM Spine Reset (Main Ebook)
              </span>
              <span className="text-teal-400 text-[15px] text-right" data-id="element-455">
                $9.87
              </span>
            </div>
            <div className="flex justify-between px-6 py-4 border-b border-white/5" data-id="element-456">
              <span className="text-white text-[15px]" data-id="element-457">
                Bonus #1: Nightstand Reset Checklist
              </span>
              <span className="text-teal-400 text-[15px] text-right" data-id="element-458">
                $27.00
              </span>
            </div>
            <div className="flex justify-between px-6 py-4 border-b border-white/5" data-id="element-459">
              <span className="text-white text-[15px]" data-id="element-460">
                Bonus #2: 3-Minute Bed Exit Guide
              </span>
              <span className="text-teal-400 text-[15px] text-right" data-id="element-461">
                $27.00
              </span>
            </div>
            <div className="flex justify-between px-6 py-4 border-b border-white/5" data-id="element-462">
              <span className="text-white text-[15px]" data-id="element-463">
                Bonus #3: 7-Day Nightly Tracker
              </span>
              <span className="text-teal-400 text-[15px] text-right" data-id="element-464">
                $27.00
              </span>
            </div>
          </div>

          <div className="bg-gold/10 border-t-2 border-gold flex justify-between px-6 py-4" data-id="element-465">
            <span className="text-gold font-bold text-[16px]" data-id="element-466">TOTAL VALUE</span>
            <span className="text-gold font-bold text-[16px] line-through decoration-gold/50" data-id="element-467">
              $98.00
            </span>
          </div>

          <div className="bg-teal-400 flex justify-between items-center px-6 py-5" data-id="element-468">
            <span className="text-navy-800 font-bold text-[18px]" data-id="element-469">
              YOUR PRICE TODAY
            </span>
            <span className="text-navy-800 font-bold text-[24px]" data-id="element-470">$9.87</span>
          </div>
        </div>

        <p className="text-white/60 text-[14px] italic text-center mt-6" data-id="element-471">
          That's over $80 in value — for less than a couple of cups of coffee.
        </p>
      </div>
    </section>;
}